import { useFetch } from "@hyper-fetch/react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { sdk } from "@/api/sdk";
import { requireSelling } from "@/features/shop/modules/offer-shell/require-selling";
import { ProductsList } from "@/features/shop/modules/products/products-list";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/offer/products/")({
  beforeLoad: requireSelling,
  loader: () => ({ crumb: m.shop_tab_products() }),
  validateSearch: z.object({
    /** Opens the editor on this product. */
    product: z.uuid().optional().catch(undefined),
  }),
  component: ProductsPage,
});

function ProductsPage() {
  const { data: settings } = useFetch(sdk.booking.settings.$get);
  const { product } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ProductsList
      currency={settings?.currency ?? "PLN"}
      openProductId={product}
      onOpenClosed={() => void navigate({ search: {}, replace: true })}
    />
  );
}
